import React, { ChangeEvent, ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Hint, Textarea, ToggleField } from '@bucketplace/commerce-admin-ui';

import { FormContent, InspectorFormProvider } from '../../components';
import { ImageField } from '../../components/Input/ImageField';
import { useFieldForm } from '../../hooks';
import { DocumentInspectorProps } from '../../types';
import { VideoProps } from './Video';

export function VideoInspector({
  value,
  onChange,
}: DocumentInspectorProps<VideoProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <VideoInspectorContent value={value} onChange={onChange} />
    </InspectorFormProvider>
  );
}

function VideoInspectorContent({
  value,
}: DocumentInspectorProps<VideoProps>): ReactElement {
  const { setValue } = useFormContext();
  const {
    fields,
    errors,
    register,
    onChange: onInputChange,
    trigger,
  } = useFieldForm();

  const errorMessage = errors['url'];

  useEffect(() => {
    register('url', {
      defaultValue: value.props.src,
      validate: async (value) => {
        const message = '유효하지 않은 비디오 URL입니다.';
        if (!value) { return; }
        try {
          const url = new URL(value);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') {
            return message;
          }
        } catch (e) {
          return message;
        }
      },
    });
  }, []);

  return (
    <>
      <FormContent header="썸네일" required>
        <ImageField name="poster" />
      </FormContent>
      <FormContent header="비디오" required>
        <Textarea
          placeholder="비디오 URL 입력"
          autoHeight
          value={fields['url']}
          onChange={(event) => {
            const value = (event as unknown as ChangeEvent<HTMLTextAreaElement>).target.value.replace(/\s/g, '');
            onInputChange('url', value);
          }}
          onBlur={async () => {
            if (!await trigger('url')) {
              setValue('src', fields['url']);
            }
          }}
        />
        { errorMessage && (
          <Hint className="hint" error>
            { errorMessage as string }
          </Hint>
        ) }
      </FormContent>
      <FormContent header="반복재생">
        <ToggleField name="loop" />
      </FormContent>
      <FormContent header="음소거">
        <ToggleField name="muted" />
      </FormContent>
      <FormContent header="자동재생">
        <ToggleField name="autoplay" />
      </FormContent>
    </>
  );
}
